import React, { useEffect, FC } from 'react';
import NProgress from 'nprogress';
import { Box, CircularProgress } from '@mui/material';

const LoadingScreen: FC = () => {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: (theme) => theme.palette.background.default,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        minHeight: '100%',
        padding: (theme) => theme.spacing(3),
      }}>
      <Box>
        <CircularProgress />
      </Box>
    </Box>
  );
};

export default LoadingScreen;
